import { AxiosResponse } from "axios";
import AuthTokenHolder from "./AuthTokenHolder";
import { showErrorModal } from "./utils";

interface ExtendAxiosResponse extends AxiosResponse {}

/**
 * 数据响应成功处理方法
 */
function successResponseHandler(response: AxiosResponse) {
  return response.data?.data;
}

/**
 * 授权过期响应处理函数
 */
function authInvalidResponseHandler() {
  AuthTokenHolder.clearToken();

  return Promise.reject(new Error("登录已过期，请刷新页面后重新登录"));
}

/**
 * 最后默认兜底的错误处理方式
 */
function defaultResponseHandler(response: ExtendAxiosResponse) {
  const requestUrl = response?.config?.url || "";

  const errorMessage = response?.data?.message || response?.data?.errorMessage;

  showErrorModal("错误信息", `请求url: ${requestUrl} 响应: ${errorMessage}`);

  return Promise.reject(new Error(errorMessage));
}

/**
 *
 * 已经拿到响应数据，根据顶层发货易数据结构顶层code 和 successful 属性判断业务失败与否
 *
 * 传入 successful || code 即可
 */
export default function responseHandler(response: AxiosResponse): any {
  /**
   * 发货易封装数据结构顶层的code
   */
  const status = response.data?.status as number;
  const success = response.data?.success as boolean;

  switch (success || status) {
    case 0:
    case true:
      return successResponseHandler(response);

    // 权限校验失败状态
    case 401:
      return authInvalidResponseHandler();

    // 权限校验失败状态
    default:
      return defaultResponseHandler(response);
  }
}
